export default __webpack_public_path__ + "static/media/Poppins-Light.6facc980.eot";